
import { loadStripe } from '@stripe/stripe-js/pure';

export default async ({ env }, inject) => {
    loadStripe.setLoadParameters({advancedFraudSignals: false});
    inject('stripe', await loadStripe(env.STRIPE_PK));
};
